export const fr = {
  common: {
    language: 'Langue',
    login: 'Connexion',
    signup: 'Inscription',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    or: 'ou',
    learnMore: 'En savoir plus',
    back: 'Retour',
    save: 'Enregistrer',
    cancel: 'Annuler',
    delete: 'Supprimer',
    edit: 'Modifier',
    loading: 'Chargement...',
    error: 'Une erreur est survenue',
    success: 'Opération réussie'
  },
  nav: {
    services: 'Nos Services',
    history: 'Notre Histoire',
    fleet: 'Notre Flotte',
    team: 'Notre Équipe',
    contact: 'Contact',
    becomeDriver: 'Devenir Chauffeur',
    about: 'À Propos'
  },
  dashboard: {
    driver: 'Chauffeur',
    passenger: 'Passager',
    stats: 'Statistiques',
    trips: 'Courses',
    upcomingTrips: 'Courses à venir',
    tripHistory: 'Historique des courses',
    profile: 'Mon profil',
    payment: 'Paiement',
    noTrips: 'Aucune course à venir',
    noTripsDescription: 'Vous n\'avez pas de courses planifiées pour le moment.'
  },
  auth: {
    email: 'Email',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: 'Vous n\'avez pas de compte ?',
    haveAccount: 'Vous avez déjà un compte ?',
    firstName: 'Prénom',
    lastName: 'Nom',
    phone: 'Téléphone',
    emailPlaceholder: 'Votre adresse email',
    passwordPlaceholder: 'Votre mot de passe',
    loginToBookTrips: 'Connectez-vous pour réserver vos trajets',
    loginToAccessDashboard: 'Connectez-vous pour accéder à votre tableau de bord',
    continueWithGoogle: 'Continuer avec Google',
    continueWithApple: 'Continuer avec Apple',
    termsAgreement: 'En te connectant, tu acceptes nos',
    termsOfUse: 'Conditions d\'utilisation',
    andOur: 'et notre',
    privacyPolicy: 'Politique de confidentialité'
  },
  booking: {
    pickup: 'Lieu de prise en charge',
    dropoff: 'Destination',
    date: 'Date',
    time: 'Heure',
    passengers: 'Passagers',
    book: 'Réserver',
    bookNow: 'Réserver maintenant'
  },
  status: {
    pending: 'En attente',
    accepted: 'Acceptée',
    ongoing: 'En cours',
    completed: 'Terminée',
    cancelled: 'Annulée'
  },
  app: {
    home: 'Accueil',
    book: 'Réserver',
    activity: 'Activité',
    profile: 'Profil',
    favorites: 'Adresses favorites',
    addFavorite: 'Ajouter une adresse',
    useAddress: 'Utiliser cette adresse',
    noFavorites: 'Aucune adresse favorite',
    settings: 'Paramètres',
    preferences: 'Préférences',
    notifications: 'Notifications',
    darkMode: 'Mode sombre',
    language: 'Langue',
    account: 'Compte',
    paymentMethods: 'Moyens de paiement',
    privacy: 'Confidentialité',
    support: 'Support',
    help: 'Aide'
  },
  home: {
    hero: {
      title: 'Bienvenue chez',
      desc: 'La meilleure expérience de transport pour tous vos déplacements. Service professionnel, ponctuel et confortable.'
    },
    booking: {
      type: {
        ride: 'Un trajet',
        hourly: 'À l\'heure'
      },
      input: {
        origin: 'Adresse de départ',
        destination: 'Adresse de destination',
        departureDate: 'Date de départ',
        departureTime: 'Heure de départ',
        returnDate: 'Date de retour',
        returnTime: 'Heure de retour'
      },
      action: {
        addReturn: 'AJOUTER LE RETOUR',
        calculating: 'CALCUL EN COURS...',
        search: 'RECHERCHER'
      },
      error: {
        departureMustBeFuture: 'L\'heure de départ doit être dans le futur',
        returnMustBeAfterDeparture: 'La date de retour ne peut pas être antérieure à la date de départ',
        selectValidAddresses: 'Veuillez sélectionner une adresse de départ et d\'arrivée valides.',
        cannotCalculateRoute: 'Impossible de calculer l\'itinéraire. Veuillez réessayer.',
        addressesRequired: 'Veuillez saisir l\'adresse de départ et d\'arrivée',
      },
      info: {
        distance: 'Distance',
        duration: 'Durée estimée',
        price: 'Prix estimé'
      }
    },
    services: {
      title: 'Nos Services',
      subtitle: 'Des solutions de transport adaptées à vos besoins',
      description: 'Chez TaxiMoove, nous nous engageons à fournir des services de transport de haute qualité, adaptés à vos besoins. Notre flotte de véhicules modernes et nos chauffeurs professionnels sont à votre disposition pour vous offrir une expérience de transport confortable, sécurisée et ponctuelle.',
      book: 'Réserver maintenant'
    },
    about: {
      title: 'Pourquoi choisir TaxiMoove ?',
      description: 'Chez TaxiMoove, nous nous distinguons par notre engagement envers l\'excellence et le service client. Notre approche unique combine professionnalisme, innovation et personnalisation pour vous offrir une expérience de transport incomparable.',
      details: {
        premium: {
          title: 'Service Premium',
          description: 'Nos chauffeurs professionnels sont soigneusement sélectionnés et formés pour vous offrir un service de qualité supérieure. Courtois, ponctuels et attentionnés, ils s\'adaptent à vos besoins spécifiques.'
        },
        security: {
          title: 'Sécurité Garantie',
          description: 'Votre sécurité est notre priorité absolue. Tous nos véhicules sont régulièrement entretenus et équipés des dernières technologies de sécurité. Nos chauffeurs suivent des formations continues en matière de sécurité routière.'
        },
        punctuality: {
          title: 'Ponctualité',
          description: 'Nous comprenons que votre temps est précieux. C\'est pourquoi nous nous engageons à être toujours ponctuels. Notre système de suivi en temps réel nous permet de vous informer précisément de l\'arrivée de votre chauffeur.'
        },
        personalization: {
          title: 'Service Personnalisé',
          description: 'Chaque client est unique, et nous adaptons notre service à vos besoins spécifiques. Que ce soit pour un trajet régulier ou occasionnel, nous créons une solution sur mesure.'
        },
        price: {
          title: 'Tarifs Transparents',
          description: 'Pas de surprises avec nos tarifs. Nous pratiquons des prix clairs et transparents, sans frais cachés. Notre calculateur de prix en ligne vous permet de connaître le coût exact de votre trajet avant la réservation.'
        },
        region: {
          title: 'Couverture Complète',
          description: 'Nous desservons toute la région avec une flotte de véhicules modernes et confortables. Que vous soyez en ville ou en périphérie, nous sommes là pour vous accompagner partout.'
        }
      },
      footer: {
        title: 'Engagement Qualité',
        description: 'Chez TaxiMoove, nous nous engageons à vous offrir une expérience de transport exceptionnelle. Notre satisfaction client est notre priorité, et nous ne cessons d\'innover pour améliorer nos services.'
      }
    },
    contact: {
      title: 'Prêt à réserver votre trajet ?',
      description: 'Notre équipe est disponible pour discuter de vos besoins de transport spécifiques et vous proposer une solution personnalisée. N\'hésitez pas à nous contacter pour obtenir un devis gratuit ou pour effectuer une réservation.',
      action: 'Contactez-nous'
    }
  },
  services: {
    hero: {
      title: 'Nos Services de Transport Premium',
      description: 'Découvrez notre gamme complète de services de transport adaptés à tous vos besoins. Des trajets quotidiens aux transferts aéroport, nous vous garantissons un service de qualité.'
    },
    standard: {
      title: 'Transport Standard',
      description: 'Service de transport confortable et fiable pour vos trajets quotidiens ou occasionnels.',
      descriptionLong: 'Service de taxi premium pour tous vos déplacements quotidiens. Que ce soit pour un rendez-vous professionnel, un événement spécial ou simplement un déplacement en ville, notre service de transport standard vous garantit confort, ponctualité et professionnalisme.',
      features: [
        'Véhicules modernes et confortables',
        'Chauffeurs professionnels',
        'Service disponible 24/7'
      ]
    },
    airport: {
      title: 'Transferts Aéroport',
      description: 'Service de transfert spécialisé pour vos trajets vers et depuis les aéroports.',
      descriptionLong: 'Service de transfert vers et depuis les aéroports en Belgique. Nous suivons l\'état de votre vol pour garantir une prise en charge à l\'heure, même en cas de retard.',
      features: [
        'Suivi des vols en temps réel',
        'Assistance avec les bagages',
        'Véhicules adaptés aux familles'
      ]
    },
    parcel: {
      title: 'Transport de Colis',
      description: 'Service de livraison rapide et sécurisé pour vos colis et documents importants.',
      descriptionLong: 'Service de livraison rapide et sécurisé pour vos colis et documents importants. Nous assurons la prise en charge et la livraison de vos envois dans les meilleurs délais.',
      features: [
        'Suivi en temps réel',
        'Livraison express',
        'Manipulation soigneuse de vos colis'
      ]
    },
    cta: {
      title: 'Prêt à réserver votre trajet ?',
      description: 'Profitez de nos services premium dès maintenant. Réservez en quelques clics et voyagez en toute sérénité.',
      button: 'Réserver maintenant'
    }
  },
  about: {
    title: 'À propos de TaxiMoove',
    ourStory: {
      title: 'Notre Histoire',
      description: 'Fondée en 2020, TaxiMoove est née de la vision d\'offrir un service de transport premium alliant confort, sécurité et ponctualité. Notre engagement envers l\'excellence nous a permis de devenir un acteur majeur du transport privé à Bruxelles.'
    },
    ourVehicles: {
      title: 'Notre Flotte',
      description: 'Explorez notre variété de véhicules premium, conçus pour répondre à tous vos besoins de transport avec confort et style.'
    },
    ourTeam: {
      title: 'Notre Équipe',
      description: 'Rencontrez les personnes passionnées qui rendent possible un service de qualité exceptionnelle jour après jour.'
    },
    ourValues: {
      title: 'Nos Valeurs',
      subtitle: 'Ces principes guident chacune de nos actions et sont au cœur de notre engagement envers vous',
      values: {
        premium: {
          title: 'Service Client Premium',
          description: 'Notre priorité absolue est votre satisfaction. Nous nous efforçons de dépasser vos attentes à chaque trajet avec un service personnalisé et attentionné.'
        },
        professional: {
          title: 'Professionnalisme',
          description: 'Nos chauffeurs sont des professionnels expérimentés, formés pour vous offrir un service de la plus haute qualité dans le respect des normes de sécurité.'
        },
        excellence: {
          title: 'Excellence',
          description: 'Nous visons l\'excellence dans chaque aspect de notre service, de la propreté de nos véhicules à la courtoisie de nos chauffeurs et la fiabilité de nos trajets.'
        }
      }
    },
    learnMore: 'En savoir plus'
  },
  ourStory: {
    title: 'Notre Histoire',
    content: [
      'TaxiMoove est né de la rencontre et de l\'amitié entre deux ingénieurs passionnés, Elias et Moukrim, qui partagent une vision commune : réinventer le service de transport urbain pour le rendre plus équitable, plus écologique et plus efficace.',
        'Avec leurs parcours complémentaires — Elias, ingénieur en physique spécialisé en photonique de l\'ULB, et Moukrim, ingénieur en électromécanique spécialisé en transport et véhicules de la VUB — ils ont uni leurs expertises pour créer une alternative aux services traditionnels qui répond aux défis contemporains de mobilité urbaine.',
        'Leur histoire est celle d\'une idée qui a mûri avec le temps, d\'une amitié qui transcende les différences linguistiques et culturelles, et d\'une ambition commune de créer un impact positif sur la société.'
    ],
    timeline: {
      title: 'Notre parcours',
      times: [
        {
          title: 'La rencontre',
          content: 'Elias de l\'ULB et Moukrim de la VUB, deux étudiants en master d\'ingénieur, se rencontrent. Malgré des parcours différents - Elias en physique spécialisé en photonique et Moukrim en électromécanique spécialisé en transport et véhicules - ils découvrent qu\'ils partagent la même ambition d\'apporter une plus-value écologique et durable à la société.'
        },
        {
          title: 'Le constat',
          content: 'En tant qu\'utilisateurs réguliers des services de transport, Elias et Moukrim constatent que les solutions existantes sont peu optimales - tant pour les clients que pour les chauffeurs et l\'environnement. Une idée commence à germer.'
        },
        {
          title: 'Le début de l\'aventure',
          content: 'Moukrim franchit le pas et investit dans l\'achat de ses premiers taxis. Convaincu du potentiel de leur vision commune, il reprend contact avec Elias pour mettre en œuvre ensemble l\'idée qu\'ils avaient esquissée des années plus tôt.',
          time: 'Fév. 2024'
        },
        {
          title: 'La naissance de TaxiMoove',
          content: 'Elias et Moukrim unissent leurs compétences complémentaires - l\'un francophone formé à l\'ULB, l\'autre néerlandophone diplômé de la VUB. Cette alliance symbolise l\'esprit même de TaxiMoove : la convergence de perspectives différentes pour créer une solution plus efficace et inclusive.',
          time: 'Mars 2024'
        },
        {
          title: 'Aujourd\'hui',
          content: 'TaxiMoove offre un modèle moderne de service de transport, aligné sur ses valeurs fondatrices : prix compétitifs pour les utilisateurs, commissions honnêtes pour les chauffeurs, véhicules moins polluants, efficacité au niveau de la réservation et excellence du service sur tous les aspects.',
        }
      ]
    },
  },
  ourValues: {
    title: 'Nos valeurs',
    description: 'Chez TaxiMoove, nos valeurs fondatrices guident chacune de nos actions et décisions, reflétant la vision de nos co-fondateurs Elias et Moukrim.',
    values: {
      ecology: {
        title: 'Durabilité écologique',
        content: 'Nous nous engageons à réduire l\'impact environnemental du transport urbain en privilégiant des véhicules moins polluants et des pratiques de conduite éco-responsables.'
      },
      equity: {
        title: 'Équité',
        content: 'Nous croyons en un modèle économique équilibré, offrant des prix compétitifs aux utilisateurs tout en garantissant des commissions justes et transparentes à nos chauffeurs partenaires.'
      },
      innovation: {
        title: 'Innovation',
        content: 'Issus de formations en ingénierie, nous appliquons notre savoir-faire pour développer des solutions technologiques qui optimisent chaque aspect du service de transport.'
      },
      excellence: {
        title: 'Excellence',
        content: 'Nous visons l\'excellence dans chaque détail : de l\'efficacité de notre système de réservation à la qualité de nos véhicules, en passant par le professionnalisme de nos chauffeurs.'
      },
    }
  },
  vehicle: {
    passengers: 'passagers',
    luggages: 'valises',
    skodaSuperbDesc: 'Berline confortable et économique, parfaite pour les déplacements urbains et professionnels.',
    toyotaPriusDesc: 'Véhicule hybride écologique avec un excellent confort pour tous vos déplacements en ville.',
    mercedesEDesc: 'Berline de luxe pour vos déplacements d\'affaires ou événements spéciaux.',
    mercedesVDesc: 'Monospace spacieux idéal pour les groupes et les familles avec beaucoup de bagages.',
    features:{
      leather: 'Intérieur cuir',
      clim: 'Climatisation',
      wifi: 'WiFi gratuit',
      usb: 'Chargeur USB',
      baby: 'Siège bébé disponibl',
      ecolo: 'Écologique',
      cardPayment: 'Paiement par carte',
      premium: 'Service premium',
      wheelchair: 'Espace pour fauteuil roulant',
      group: 'Parfait pour groupes'
    }
  },
  ourVehicles: {
    title: 'Notre Flotte',
    description: 'TaxiMoove dispose d\'une flotte diversifiée pour répondre à tous vos besoins de transport. Nos véhicules sont récents, entretenus régulièrement et conduits par des chauffeurs professionnels.',
    why: 'Pourquoi choisir notre flotte',
    values: {
      recent: {
        title: 'Véhicules récents',
        content: 'Notre flotte est composée exclusivement de véhicules récents (moins de 3 ans) pour vous garantir confort et fiabilité.'
      },
      maintenance: {
        title: 'Entretien régulier',
        content: 'Tous nos véhicules sont minutieusement entretenus et nettoyés avant chaque course pour vous offrir une expérience irréprochable.'
      },
      equipment: {
        title: 'Équipements premium',
        content: 'WiFi gratuit, bouteilles d\'eau, chargeurs pour téléphones... Nous pensons à tout pour que votre trajet soit aussi agréable que possible.'
      }
    }
  },
  team: {
    cofounder: 'Co-Fondateur',
	driver: 'Chauffeur',
    eliasDesc: 'Elias a cofondé TaxiMoove avec une vision claire : offrir un service de transport de qualité supérieure en mettant l\'accent sur la satisfaction client.',
    moukrimDesc: 'Moukrim supervise l\'ensemble des opérations quotidiennes, assurant une coordination parfaite entre nos chauffeurs et nos clients pour garantir un service impeccable.'
  },
  ourTeam: {
    title: 'Notre Équipe',
    description: 'Chez TaxiMoove, notre équipe est notre plus grand atout. Composée de professionnels passionnés et expérimentés, chaque membre partage la même vision : vous offrir une expérience de transport exceptionnelle. Découvrez les personnes qui travaillent chaque jour pour faire de votre trajet un moment agréable et sans souci.',
    values: {
      title: 'Nos valeurs d\'équipe',
      subtitle: 'Notre équipe partage des valeurs fondamentales qui guident nos actions et notre service quotidien.',
      excellency: {
        title: 'Excellence',
        content: 'Chaque membre de notre équipe s\'engage à fournir un service d\'excellence, dépassant les attentes des clients à chaque trajet.'
      },
      professional: {
        title: 'Professionnalisme',
        content: 'Nos chauffeurs et notre personnel administratif font preuve d\'un professionnalisme irréprochable dans toutes leurs interactions.'
      },
      cohesion: {
        title: 'Esprit d\'équipe',
        content: 'Nous travaillons ensemble, en synergie, pour assurer une expérience fluide et coordonnée pour tous nos clients.'
      }
    }
  },
  transport: {
    standard: {
      title: 'Transport Standard',
      description: 'Notre service de transport standard est conçu pour répondre à tous vos besoins de déplacement quotidiens avec un niveau de service et de confort supérieur. Que ce soit pour un trajet professionnel, un rendez-vous important ou une sortie en ville, nous vous garantissons une expérience impeccable.',
      values: {
        quality: {
          title: 'Confort et Qualité',
          content: 'Tous nos véhicules sont récents, climatisés et parfaitement entretenus pour vous garantir un confort optimal. Nos chauffeurs, courtois et professionnels, sont à votre service pour rendre votre trajet agréable.'
        },
        reservation: {
          title: 'Réservation Facile',
          content: 'Réservez votre course en quelques clics via notre site web ou notre application mobile. Vous pouvez également nous contacter par téléphone pour une réservation immédiate ou future.'
        },
        available: {
          title: 'Disponibilité',
          content: 'Notre service est disponible 24h/24 et 7j/7, pour répondre à tous vos besoins de déplacement, peu importe l\'heure ou le jour. Vous pouvez compter sur nous à tout moment.'
        },
      },
      footer: {
        title: 'Bon à savoir',
        content: 'Pour nos clients réguliers, nous proposons des formules d\'abonnement avantageuses. Contactez-nous pour en savoir plus sur nos offres personnalisées pour les particuliers et les entreprises.'
      }
    },
    airport: {
      title: 'Transferts Aéroports & Gares',
      description: 'Notre service de transfert aéroports et gares vous offre une solution fiable et confortable pour tous vos déplacements de et vers les principales infrastructures de transport en Belgique. Nous prenons en charge le suivi de votre vol ou train et adaptons notre service en conséquence.',
      airport: {
        title: 'Aéroports desservis',
        subtitle: 'Nous assurons des transferts vers et depuis tous les principaux aéroports belges :',
        bru: 'Aéroport de Bruxelles (BRU)',
        crl: 'Aéroport de Charleroi (CRL)',
        anvers: 'Aéroport d\'Anvers',
        ostende: 'Aéroport d\'Ostende-Bruges',
        lgg: 'Aéroport de Liège (LGG)'
      },
      station: {
        title: 'Gares desservies',
        subtitle: 'Nous assurons également des transferts vers et depuis les principales gares en Belgique :',
        bruMidi: 'Gare de Bruxelles-Midi',
        bruCentral: 'Gare de Bruxelles-Central',
        bruNorth: 'Gare de Bruxelles-Nord',
        anvers: 'Gare d\'Anvers-Central',
        gand: 'Gare de Gand-Saint-Pierre',
        louvain: 'Gare de Louvain',
        malines: 'Gare de Malines',
        bruges: 'Gare de Bruges'
      },
      values: {
        track: {
          title: 'Suivi en temps réel',
          content: 'Nous suivons l\'état de votre vol ou train en temps réel pour nous adapter aux éventuels retards sans frais supplémentaires. Votre chauffeur vous attendra, même en cas de retard important.'
        },
        reservation: {
          title: 'Réservation à l\'avance',
          content: 'Réservez votre transfert à l\'avance pour garantir votre prise en charge. Indiquez simplement votre numéro de vol ou de train et nous nous occupons du reste.'
        }
      },
      footer: {
        title: 'Important',
        content: 'Pour les transferts aéroport, nous vous recommandons de réserver au moins 24 heures à l\'avance. Pour les arrivées internationales, votre chauffeur vous attendra à la sortie de la zone de récupération des bagages avec une pancarte à votre nom.'
      }
    },
    parcel: {
      title: 'Transfert de colis',
      description: [
          'Notre service de transfert de colis vous offre une solution rapide, fiable et sécurisée pour l\'acheminement de vos colis et documents importants. Idéal pour les entreprises et les particuliers ayant besoin d\'un service de livraison express.',
          'Avec TaxiMoove, vous bénéficiez d\'un service personnalisé, d\'une traçabilité en temps réel et d\'une manipulation soigneuse de vos envois. Notre équipe de chauffeurs expérimentés s\'engage à respecter les délais les plus courts possible pour répondre à vos besoins.'
      ],
      features: {
        express: {
          title: 'Livraison Express',
          content: 'Nous garantissons un service de livraison rapide pour tous vos colis et documents urgents. Notre équipe s\'engage à respecter les délais les plus courts possible pour répondre à vos besoins.'
        },
        security: {
          title: 'Sécurité Maximale',
          content: 'Vos colis sont manipulés avec le plus grand soin par nos chauffeurs formés. Nous assurons une traçabilité complète et un suivi en temps réel de votre envoi.'
        },
        speed: {
          title: 'Service Rapide',
          content: 'Notre service est disponible 24h/24 et 7j/7 pour répondre à vos besoins urgents. Réservez en ligne ou par téléphone pour une prise en charge immédiate.'
        },
        personalized: {
          title: 'Service Personnalisé',
          content: 'Nous adaptons notre service à vos besoins spécifiques, qu\'il s\'agisse de colis volumineux, fragiles ou nécessitant des conditions particulières de transport.'
        },
        region: {
          title: 'Couverture Complète',
          content: 'Service disponible dans toute la région bruxelloise et en Flandre. Nous assurons des livraisons ponctuelles et fiables à destination.'
        },
        tracking: {
          title: 'Suivi en Temps Réel',
          content: 'Suivez l\'état de votre livraison en temps réel grâce à notre système de traçabilité. Recevez des notifications à chaque étape de votre envoi.'
        }
      },
      footer: {
        title: 'Important',
        content: [
            'Pour garantir un service optimal, nous vous recommandons de :',
            [
                'Emballer correctement vos colis pour le transport',
                'Fournir des informations précises sur le contenu',
                'Indiquer clairement l\'adresse de livraison',
                'Prévoir un contact disponible à l\'adresse de livraison'
            ],
            'Pour les entreprises effectuant des envois réguliers, nous proposons des forfaits mensuels avantageux. Contactez-nous pour obtenir une offre personnalisée adaptée à votre volume d\'envois.'
        ]
      }
    }
  },
  contact: {
    title: 'Contactez-nous',
    subtitle: 'Nous sommes à votre écoute pour toutes vos questions',
    name: {
      label: 'Nom complet',
      placeholder: 'Votre nom'
    },
    email: {
      label: 'Email',
      placeholder: 'Votre email'
    },
    phone: {
      label: 'Téléphone',
      placeholder: 'Votre téléphone'
    },
    subject: {
      label: 'Sujet',
      placeholder: 'Sujet de votre message'
    },
    message: {
      label: 'Message',
      placeholder: 'Votre message'
    },
    action: {
      submitting: 'Envoi en cours...',
      submit: 'Envoyer le message'
    },
    success: 'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.'
  },
  becomeDriver: {
    title: 'Devenez Chauffeur TaxiMoove',
    description: 'Rejoignez notre équipe de chauffeurs professionnels et profitez d\'une carrière flexible avec des revenus attractifs. Chez TaxiMoove, nous valorisons le professionnalisme et l\'excellence du service.',
    requirements: {
      vehicle: {
        title: 'Véhicule Personnel',
        content: 'Possédez un véhicule personnel en excellent état, récent et bien entretenu. Le véhicule doit répondre à nos critères de qualité et de confort.'
      },
      experience: {
        title: 'Expérience Professionnelle',
        content: 'Ayez au moins 2 ans d\'expérience de conduite professionnelle. Une expérience dans le transport de personnes est un plus.'
      },
      documents: {
        title: 'Permis et Documents',
        content: 'Possédez un permis de conduire valide depuis plus de 3 ans. Aucun antécédent judiciaire et casier judiciaire vierge.'
      },
    },
    benefits: {
      title: 'Les Avantages de Rejoindre TaxiMoove',
      money: {
        title: 'Revenus Attractifs',
        content: 'Profitez de revenus compétitifs avec des bonus et des pourboires. Gagnez plus en travaillant aux heures de pointe.'
      },
      flexibility: {
        title: 'Flexibilité Totale',
        content: 'Gérez votre emploi du temps comme vous le souhaitez. Choisissez vos horaires et vos zones de travail.'
      },
      support: {
        title: 'Support Continu',
        content: 'Bénéficiez d\'un support technique et administratif 24/7. Formation continue et opportunités d\'évolution.'
      },
    },
    apply: 'Postuler Maintenant'
  },
  search: {
    services: {
      transport: 'Transport',
      transfer: 'Transfert',
      parcel: 'Colis'
    },
    vehicles: {
      economy: 'Économie',
      standard: 'Standard',
      van: 'Van'
    },
    capacity: 'personnes',
    origin: {
      label: 'Origine',
      placeholder: 'Adresse de départ'
    },
    destination: {
      label: 'Destination',
      placeholder: 'Adresse d\'arrivée'
    },
    startDate: 'Date de départ',
    startTime: 'Heure de départ',
    returnDate: 'Date de retour',
    returnTime: 'Heure de retour',
    flightNumber: 'Numéro de vol',
    nametag: 'Nametag',
    weight: 'Poids',
    dimensions: 'Dimensions',
    description: {
      label: 'Description',
      placeholder: 'Description du colis'
    },
    distance: 'Distance',
    duration: 'Durée',
    error: {
      noDataFound: 'Aucune information de voyage trouvée. Veuillez effectuer une nouvelle recherche.',
      noSelectedVehicle: 'Veuillez sélectionner un véhicule pour continuer.'
    },
    action: {
      addReturn: 'AJOUTER LE RETOUR',
      loading: 'Chargement...',
      book: 'Réserver maintenant'
    }
  },
  payment: {
    title: 'Paiement sécurisé',
    name: 'Nom sur la carte',
    phone: 'Téléphone',
    card: 'Détails de la carte',
    action: {
      processing: 'Traitement en cours...',
      pay: 'Payer',
      loading: 'Chargement...',
      return: 'Retour'
    },
    success: 'Paiement effectué avec succès ! Redirection en cours...',
    notice: 'Paiement sécurisé avec Stripe. Vos données de carte sont cryptées.',
    error: {
      noDataFound: 'Aucune information de réservation trouvée. Veuillez effectuer une nouvelle recherche.'
    },
    summary: 'Récapitulatif de la commande',
    services: {
      label: 'Service',
      transport: 'Transport',
      transfer: 'Transfert',
      parcel: 'Colis'
    },
    vehicle: 'Véhicule',
    itinerary: 'Trajet',
    date: 'Date',
    return: 'Retour',
    flightNumber: 'Numéro du vol',
    weight: 'Poids',
    dimensions: 'Dimensions',
    description: 'Description',
    total: 'Total',
    secure: 'Paiement sécurisé',
    methods: {
      select: 'Moyen de paiement',
      card: 'Carte bancaire',
      paypal: 'Paypal',
      bancontact: 'Bancontact'
    }
  },
  paymentReturn: {
    redirect: 'Redirection automatique dans quelques secondes...',
    retry: 'Réessayer',
    goHome: 'Retour à l\'accueil',
    status: {
      success: 'Paiement Réussi',
      error: 'Erreur de Paiement',
      processing: 'Traitement en Cours'
    },
    statusDesc: {
      success: 'Votre paiement a été traité avec succès. Traitement de votre commande en cours...',
      error: 'Erreur de Paiement',
      processing: 'Votre paiement est en cours de traitement. Veuillez patienter...'
    },
    errors: {
      general: 'Une erreur est survenue lors de la vérification du paiement.',
      canceled: 'Le paiement a été annulé. Vous pouvez réessayer si vous le souhaitez.',
      requiresPaymentMethod: 'Votre paiement n\'a pas pu être traité. Veuillez essayer avec une autre méthode de paiement.',
      unknown: 'Le statut du paiement est inconnu. Veuillez contacter le support si nécessaire.'
    }
  },
  paymentSuccess: {
    title: 'Paiement Confirmé',
    subtitle: 'Merci pour votre réservation !',
    confirmationCode: 'Votre code de confirmation est :',
    details: {
      title: 'Détails de votre réservation'
    },
    price: 'Montant payé',
    instructionsTitle: 'Que se passe-t-il maintenant ?',
    instructions: [
        'Un email de confirmation a été envoyé à votre adresse.',
        'Notre équipe vous contactera pour confirmer les détails de votre réservation.',
        'Pour toute question, n\'hésitez pas à nous contacter.'
    ],
    returnHome: 'Retour à l\'accueil',
    contactUs: 'Nous contacter'
  },
  profile: {
    accountInfo: 'Informations du compte',
    editProfile: 'Modifier le profil',
    savedAddresses: 'Adresses enregistrées',
    paymentMethods: 'Moyens de paiement',
    security: 'Sécurité',
    changePassword: 'Changer le mot de passe',
    twoFactorAuth: 'Authentification à deux facteurs',
    preferences: 'Préférences',
    language: 'Langue',
    appearance: 'Apparence',
    silentRide: 'Trajet silencieux',
    petFriendly: 'Trajet avec animal',
    notifications: 'Notifications',
    other: 'Autre',
    referral: 'Parrainage',
    legal: 'Mentions légales',
    logout: 'Déconnexion',
    title: 'Mon profil',
    theme: 'Thème',
    help: 'Aide et Support'
  },
  password: {
    title: 'Changer le mot de passe',
    current: 'Mot de passe actuel',
    new: 'Nouveau mot de passe',
    confirm: 'Confirmer le mot de passe',
    change: 'Changer le mot de passe',
    mismatch: 'Les mots de passe ne correspondent pas',
    tooShort: 'Le mot de passe doit contenir au moins 8 caractères',
    changeError: 'Erreur lors du changement du mot de passe',
    changeSuccess: 'Mot de passe modifié avec succès'
  },
  language: {
    title: 'Choisir la langue',
    french: 'Français',
    english: 'Anglais'
  },
  theme: {
    title: 'Choisir le thème',
    light: 'Clair',
    dark: 'Sombre'
  },
  referral: {
    title: 'Programme de parrainage',
    yourCode: 'Votre code de parrainage',
    description: 'Partagez votre code de parrainage avec vos amis et gagnez des récompenses !',
    copy: 'Copier',
    copied: 'Copié !',
    referrals: 'Parrainages',
    earned: 'Gains',
    pending: 'En attente'
  },
  legal: {
    title: 'Mentions légales',
    terms: {
      title: 'Conditions générales',
      lastUpdated: 'Dernière mise à jour : 1er mars 2024',
      intro: 'En utilisant notre service, vous acceptez les conditions suivantes :',
      terms1: 'Vous devez avoir au moins 18 ans pour utiliser ce service',
      terms2: 'Vous êtes responsable de la confidentialité de votre compte',
      terms3: 'Nous nous réservons le droit de modifier ces conditions à tout moment'
    },
    privacy: {
      title: 'Politique de confidentialité',
      intro: 'Nous prenons la protection de vos données personnelles très au sérieux.',
      points1: 'Nous collectons uniquement les données nécessaires au fonctionnement du service',
      points2: 'Vos données ne sont jamais vendues à des tiers',
      points3: 'Vous pouvez demander la suppression de vos données à tout moment'
    },
    cookies: {
      title: 'Politique des cookies',
      intro: 'Nous utilisons des cookies pour améliorer votre expérience.',
      types1: 'Cookies essentiels pour le fonctionnement du site',
      types2: 'Cookies analytiques pour améliorer nos services',
      types3: 'Cookies de préférences pour sauvegarder vos choix'
    },
    contact: {
      title: 'Contact',
      email: 'Email : contact@taximoove.com',
      address: 'Adresse : 123 rue de la Paix, 75000 Paris',
      phone: 'Téléphone : +33 1 23 45 67 89'
    }
  },
  help: {
    title: 'Aide et Support',
    chat: {
      title: 'Chat en direct',
      description: 'Discutez en temps réel avec notre équipe de support',
      welcome: 'Bonjour ! Comment pouvons-nous vous aider aujourd\'hui ?',
      placeholder: 'Écrivez votre message...',
      autoResponse: 'Merci pour votre message. Un membre de notre équipe vous répondra dans quelques instants.'
    },
    phone: {
      title: 'Support téléphonique',
      description: 'Appelez-nous pour une assistance immédiate',
      hours: 'Lundi - Vendredi : 9h00 - 18h00',
      availability: 'Disponible en France et à l\'international'
    },
    email: {
      title: 'Support par email',
      description: 'Envoyez-nous un email et nous vous répondrons dans les plus brefs délais',
      subject: 'Sujet',
      subjectPlaceholder: 'Entrez le sujet de votre message',
      message: 'Message',
      messagePlaceholder: 'Décrivez votre demande en détail',
      send: 'Envoyer'
    },
    faq: {
      title: 'Questions fréquentes',
      searchPlaceholder: 'Rechercher dans les FAQ...',
      questions: {
        q1: 'Comment réserver un trajet ?',
        q2: 'Comment modifier une réservation ?',
        q3: 'Quels sont les moyens de paiement acceptés ?',
        q4: 'Comment annuler une réservation ?',
        q5: 'Comment devenir chauffeur ?'
      },
      answers: {
        a1: 'Pour réserver un trajet, connectez-vous à votre compte, sélectionnez votre point de départ et d\'arrivée, choisissez votre véhicule et confirmez la réservation.',
        a2: 'Vous pouvez modifier votre réservation jusqu\'à 1 heure avant le trajet en accédant à la section "Mes trajets" de votre compte.',
        a3: 'Nous acceptons les cartes bancaires (Visa, Mastercard, American Express), PayPal et les virements bancaires.',
        a4: 'Pour annuler une réservation, accédez à la section "Mes trajets", sélectionnez le trajet concerné et cliquez sur "Annuler".',
        a5: 'Pour devenir chauffeur, remplissez le formulaire d\'inscription dans la section "Devenir chauffeur" et soumettez les documents requis.'
      }
    }
  },
  footer: {
    about: {
      title: 'À propos',
      ourStory: 'Notre histoire',
      ourVehicles: 'Notre flotte',
      ourTeam: 'Notre équipe',
      contact: 'Nous contacter',
    },
    services: {
      title: 'Services',
      standard: 'Transport Standard',
      airport: 'Transferts Aéroports',
      parcel: 'Transfert Colis',
    },
    contact: {
      title: 'Contact',
      email: 'Email',
      phone: 'Tél'
    },
    join: {
      title: 'Rejoignez-nous',
      becomeDriver: 'Devenir chauffeur'
    },
    copyright: {
      allRightsReserved: 'Tous droits réservés.',
      mentions: 'Mentions légales',
      terms: 'Conditions générales',
      confidentiality: 'Politique de confidentialité'
    }
  }
}; 